import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as CollectionActions from './collection.actions';
import { AccountClientService } from '@mode/shared/data-access-webapp';
import { of } from 'rxjs';

@Injectable()
export class CollectionEffects {
  loadCollections$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CollectionActions.loadCollections),
      switchMap((action) => this.accountClient.getCollections(action.username)),
      map((collections) => collections.sort((a, b) => a.name.localeCompare(b.name))),
      map((collections) => CollectionActions.loadCollectionsSuccess({ collections })),
      catchError((err, caught) => of(CollectionActions.loadCollectionsFailure({ error: err })))
    );
  });

  refreshCollections$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CollectionActions.refreshCollections),
      switchMap((action) => this.accountClient.getCollections(action.username, true)),
      map((collections) => CollectionActions.loadCollectionsSuccess({ collections })),
      catchError((err, caught) => of(CollectionActions.loadCollectionsFailure({ error: err })))
    );
  });

  constructor(
    private actions$: Actions,
    private accountClient: AccountClientService
  ) {}
}
